import JoinForm from "@/components/JoinForm";

export default function JoinTheBand() {
  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <h2 className="font-['Playfair_Display'] text-4xl text-center mb-8 text-[#4A1D6E]">Join the Band</h2>
        <p className="text-center max-w-2xl mx-auto mb-12 text-lg">
          Thank you for contacting Clyde Wind Ensemble. Please fill in the form below and we will get back to you as soon as possible.
        </p>
        
        <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-lg p-8">
          <JoinForm />
        </div>
      </div>
    </section>
  );
}
